import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IReactSelectOptionObject } from "@atman/business";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ValueContainerProps, components } from "react-select";

export interface IMaxItemsValueContainerProps<TValue = IReactSelectOptionObject[]> extends ValueContainerProps<TValue> {
    maxNumberOfValuesToDisplay?: number;
    icon?: IconProp;
}

export const MaxItemsValueContainer: React.FC<IMaxItemsValueContainerProps> = (props) => {
    const { maxNumberOfValuesToDisplay = 3, children, icon, ...otherProps } = props;

    const length = props.getValue()?.length ?? 0;

    const childElements = React.Children.toArray(children);
    const inputElement = childElements.pop();
    const displayBadges = length === 0 ? childElements : childElements.slice(0, maxNumberOfValuesToDisplay);
    const shouldBadgeShow = length > maxNumberOfValuesToDisplay;
    const displayLength = length - maxNumberOfValuesToDisplay;

    return (
        <components.ValueContainer {...otherProps}>
            {icon ? <FontAwesomeIcon icon={icon} style={{ marginRight: 12 }} /> : null}
            {displayBadges}
            {!props.selectProps.inputValue && (
                <div className="root" style={{ marginLeft: 8 }}>
                    {shouldBadgeShow &&
                        `+ ${displayLength} ${"item".localize().toLowerCase()}${
                            length != 1 ? "s" : ""
                        } ${"global.selected".localize().toLowerCase()}`}
                </div>
            )}
            {inputElement}
        </components.ValueContainer>
    );
};
